import YouTubeEmbed from './youtube-embed';
export default YouTubeEmbed;
export type { Props as YouTubeEmbedProps } from './youtube-embed';
export { ytReady, isPlaying, type YouTubePlayer, type YouTubeApi } from './youtube-api';
